import { render, staticRenderFns } from "./quClothes.vue?vue&type=template&id=51fd8659&scoped=true&"
import script from "./quClothes.vue?vue&type=script&lang=js&"
export * from "./quClothes.vue?vue&type=script&lang=js&"
import style0 from "./quClothes.vue?vue&type=style&index=0&id=51fd8659&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd8659",
  null
  
)

export default component.exports